import React, { useEffect, useState } from "react";
import "../../Styles/navbar.css";
import "./style/home.css";
import "../../Styles/placeholder.css";
import { inject, observer } from "mobx-react";
import { SearchOutlined } from "@ant-design/icons";
import calllIcon from "../../Assets/callIcon.svg";
import Corona from "../../Assets/Corona.png";
import Logo2 from "../../Assets/logo2.svg";
import { useHistory } from "react-router-dom";
import axios from "axios";
import Header from "../Headers/Header";
import { Colors, HexColors } from "../../Utils/colors";
import { Avatar, message } from "antd";
import { UserOutlined } from "@ant-design/icons";
import PatientHomeScreenCards from "./PatientHomeScreenCards";
import Sidebar from "../Headers/sidebar";
import BookDoctorCard from "./BookDoctorCard";
import WellnessCheckCard from "./WellnessCheckCard";

const Home = inject("store")(
  observer(({ store, data }) => {
    const history = useHistory();
    const [patientList, setPatientList] = useState([]);
    const [user, setUser] = useState({});
    const patient = user;

    const [medData, setMedData] = useState([]);
    const [showData, setShowData] = useState(false);
    const [blur, setBlur] = useState(false);
    const handleSearch = (e) => {
      if (e.target.value === "") {
        setBlur(false);
      }
      if (localStorage.access && localStorage.refresh) {
        axios
          .get(`api/vol/search/?query=${e.target.value}`, {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.access,
            },
          })
          .then((res) => {
            console.log(res.data.data);
            setMedData(res.data.data);
          })
          .catch(() => console.log("Not Found"));

        setShowData(true);
      }
    };
    useEffect(() => {
      if (localStorage.user_type === null) {
        localStorage.setItem("user_type", 4);
      }

      if (localStorage.access && localStorage.refresh) {
        axios
          .get("api/auth/user/", {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.access,
            },
          })
          .then((res) => {
            if (res.data.status) {
              setUser(res.data.data);
              store.setUser(res.data.data.name, res.data.data.profile_pic);
              localStorage.setItem("userId", res.data.data.id);
            }
          });
      }
      // eslint-disable-next-line
    }, []);

    useEffect(() => {
      if (localStorage.access && localStorage.refresh) {
        axios
          .get("api/pat/patient-list/", {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.access,
            },
          })
          .then((res) => {
            console.log("pat", res.data.data);
            setPatientList(res.data.data);
          });
      }
    }, []);
    return (
      <div className="overflowX-hidden">
        <div className="mobile">
          <Header user={user} />
        </div>
        <div className="flex">
          <div className="websites">
            <Sidebar />
          </div>
          <div className="web">
            <div className="mx-6 m-2 mt-2" onClick={() => setShowData(false)}>
              <div className="header-patient">
                <div>
                  <div
                    className="searchb rounded-2xl mt-10  mx-auto md:max-w-2xl p-1 pl-4"
                    style={{
                      boxShadow: "0px 0px 10px 5px rgba(0, 0, 0, 0.03)",
                    }}
                  >
                    <input
                      name="query"
                      className="rounded-2xl py-1 pl-2 search"
                      style={{ width: "90%" }}
                      placeholder="Search for hospitals,doctors etc"
                      onChange={(e) => {
                        handleSearch(e);
                        setBlur(true);
                      }}
                      autoComplete="off"
                    />
                    {showData && (
                      <div
                        className="bg-white text-left"
                        style={{
                          color: "black",
                          width: "83%",
                          marginRight: "10px",
                          boxShadow: "0px 0px 10px 5px rgba(0, 0, 0, 0.03)",
                          borderRadius: "0px 0px 22px 22px",
                          fontSize: "12px !important",
                          position: "absolute",
                          zIndex: "5",
                        }}
                      >
                        {medData.map((data, index) => (
                          <>
                            <div
                              className="my-2 mx-2"
                              onClick={() => {
                                setBlur(false);
                              }}
                              style={{
                                color: "black",
                                borderRadius: "2px",
                                width: "18.25rem",
                                marginBottom: "12px",
                                marginRight: "10px",
                              }}
                              key={index}
                              // onClick={() => { setMedicine(data.med); setMed(data.id); setQuery(data.med); setShowData(false); }}
                            >
                              <div
                                className=" flex justify-between"
                                style={{
                                  alignItems: "center",
                                  marginLeft: "10px",
                                }}
                              >
                                <div className="">
                                  <p className="font-sm">{data.name}</p>
                                  <p
                                    className="font-xs"
                                    style={{ color: "rgba(210, 210, 210, 1)" }}
                                  >
                                    {data.type}
                                  </p>
                                </div>
                                {(data.type === "Hospital" ||
                                  data.type === "Ambulance" ||
                                  data.type === "Pharma") && (
                                  <>
                                    {" "}
                                    <div className="-pr-3">
                                      <a href={`tel:${data.mobile}`}>
                                        <div
                                          style={{
                                            alignItems: " center",
                                            background: "#717EF0",
                                          }}
                                          className=" w-16 flex justify-around h-7 rounded-lg "
                                        >
                                          <p className=" font-semibold text-white">
                                            Call
                                          </p>
                                          <img src={calllIcon} alt="" />
                                        </div>
                                      </a>
                                    </div>{" "}
                                  </>
                                )}
                              </div>
                              <p
                                className="font-xs pb-2 mr-4"
                                style={{
                                  marginLeft: "10px",
                                  width: "297px",
                                  color: "#C0BABA",
                                  borderBottom: "1px solid #CACACA",
                                }}
                              >
                                {data.content}
                              </p>
                            </div>
                          </>
                        ))}
                      </div>
                    )}
                    <button className="pr-4" style={{ width: "10%" }}>
                      <SearchOutlined />
                    </button>
                  </div>
                </div>
                <div
                  onClick={() => {
                    history.push("/patientprofile");
                  }}
                  className="flex mt-10 cursor-pointer icon-patient"
                  style={{
                    alignItems: "center",
                    boxShadow: "0px 0px 9px rgba(0, 0, 0, 0.1)",
                    borderRadius: "24px",
                  }}
                >
                  <div
                    style={{ minWidth: "7.9vw", width: "70px" }}
                    className="mr-2 bottom-2 pl-2 truncate"
                  >
                    {localStorage.access && localStorage.refresh
                      ? patient
                        ? patient.name
                        : "Hello"
                      : "Guest"}
                  </div>
                  {/* <img className="inline-block h-8 w-8 rounded-full ring-2 ring-white" src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="" /> */}
                  {patient.profile_pic ? (
                    <Avatar
                      className="inline-block rounded-full ring-2 ring-white"
                      style={{ height: "2rem", width: "2rem" }}
                      src={patient.profile_pic}
                      // icon={patient.profile_pic ? patient.profile_pic : <UserOutlined />}
                    />
                  ) : (
                    <Avatar
                      className="inline-block rounded-full ring-2 ring-white"
                      style={{ height: "2rem", width: "2rem" }}
                      // src={patient.profile_pic}
                      icon={<UserOutlined />}
                    />
                  )}
                </div>
              </div>
              <h1 className="font-normal text-2xl mt-4 md:text-center ml-4 ">
                Namaste
              </h1>
              <div
                onClick={() => {
                  setBlur(false);
                }}
                style={{ filter: blur ? "blur(2px)" : "none" }}
              >
                <div className="buttons align-middle">
                  <button
                    className="text-xs w-24 h-24 m-1 text-white"
                    style={{
                      borderRadius: "10px",
                      alignItems: "center",
                      boxShadow: "0px 0px 10px 4px rgba(0, 0, 0, 0.05)",
                    }}
                  >
                    <div className="mx-auto w-5 ">
                      <svg
                        className="-ml-1"
                        width="24"
                        height="32"
                        viewBox="0 0 24 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.40176 0.734235L6.23224 0.18368C7.23499 -0.118696 8.3135 -0.0459056 9.26652 0.388467C10.2195 0.822841 10.982 1.58912 11.4115 2.54432L12.8264 5.6908C13.1957 6.5124 13.2985 7.42901 13.1205 8.31203C12.9424 9.19505 12.4924 10.0002 11.8335 10.6144L9.49008 12.7994C9.42158 12.8632 9.37819 12.9495 9.36774 13.0425C9.29872 13.6652 9.72066 14.8777 10.6931 16.5639C11.4006 17.7889 12.0421 18.65 12.5864 19.1316C12.966 19.4688 13.1746 19.5409 13.264 19.5158L16.4167 18.5512C17.2777 18.2878 18.1995 18.3005 19.0529 18.5874C19.9064 18.8743 20.6486 19.4211 21.1757 20.1511L23.1849 22.9368C23.796 23.784 24.0788 24.824 23.981 25.864C23.8833 26.9039 23.4114 27.873 22.6532 28.5914L21.2635 29.9089C20.5259 30.6074 19.62 31.103 18.634 31.3473C17.648 31.5917 16.6156 31.5766 15.6372 31.3034C11.3174 30.0972 7.44472 26.4519 3.97512 20.4429C0.500822 14.426 -0.717928 9.24353 0.405141 4.89398C0.657951 3.91575 1.15849 3.01912 1.8585 2.29053C2.55852 1.56194 3.43441 1.02596 4.40176 0.734235ZM5.08094 2.98822C4.5007 3.16304 3.97524 3.48432 3.5552 3.92113C3.13515 4.35794 2.83465 4.89555 2.68265 5.48218C1.73839 9.14 2.81911 13.7342 6.01265 19.2665C9.20147 24.7908 12.635 28.022 16.2709 29.0384C16.8577 29.2019 17.4769 29.2106 18.0681 29.0638C18.6593 28.9171 19.2025 28.6197 19.6448 28.2008L21.0361 26.8832C21.3808 26.5567 21.5954 26.116 21.6398 25.6432C21.6842 25.1704 21.5555 24.6975 21.2776 24.3124L19.2699 21.5283C19.0303 21.1961 18.6927 20.9472 18.3045 20.8167C17.9163 20.6862 17.4969 20.6805 17.1053 20.8005L13.9447 21.7683C12.1095 22.3141 10.4438 20.8381 8.65562 17.7403C7.45099 15.6541 6.88946 14.0385 7.02906 12.7821C7.10278 12.1296 7.4055 11.5273 7.88548 11.0787L10.2289 8.89374C10.5285 8.61457 10.7332 8.24858 10.8142 7.84714C10.8952 7.44571 10.8485 7.02898 10.6806 6.65545L9.26578 3.50897C9.07053 3.07513 8.7242 2.72708 8.29132 2.52969C7.85845 2.33229 7.36857 2.29903 6.91298 2.43609L5.08094 2.98822Z"
                          fill={
                            store.color === Colors.allopathic
                              ? HexColors.allopathic
                              : store.color === Colors.homeopathic
                              ? HexColors.homeopathic
                              : HexColors.ayurvedic
                          }
                        />
                      </svg>
                    </div>
                    <div
                      className="mt-4 font-semibold text-center"
                      style={{
                        color:
                          store.color === Colors.allopathic
                            ? HexColors.allopathic
                            : store.color === Colors.homeopathic
                            ? HexColors.homeopathic
                            : HexColors.ayurvedic,
                      }}
                    >
                      Call
                    </div>
                  </button>

                  <button
                    className="single text-xs w-24 h-24 m-1 text-white"
                    onClick={() => {
                      if (localStorage.access && localStorage.refresh) {
                        if (patientList.length === 0) {
                          history.push("/patientform");
                        } else {
                          history.push("/patientlist", {
                            patientList: patientList,
                          });
                        }
                      } else {
                        history.push("/login");
                        message.warning("Please login");
                      }
                    }}
                    style={{
                      borderRadius: "10px",
                      alignItems: "center",
                      boxShadow: "0px 0px 10px 4px rgba(0, 0, 0, 0.05)",
                    }}
                  >
                    <div className="mx-auto w-5 ">
                      <svg
                        className="-ml-1"
                        width="30"
                        height="28"
                        viewBox="0 0 30 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17.5935 22.7913C22.4938 22.7913 24.9445 22.7913 26.4662 21.2684C27.9892 19.7467 27.9892 17.2959 27.9892 12.3957C27.9892 7.49541 27.9892 5.04463 26.4662 3.52297C24.9445 2 22.4938 2 17.5935 2H12.3957C7.49541 2 5.04463 2 3.52297 3.52297C2 5.04463 2 7.49541 2 12.3957C2 17.2959 2 19.7467 3.52297 21.2684C4.37151 22.1182 5.50854 22.4938 7.19784 22.6588"
                          stroke={
                            store.color === Colors.allopathic
                              ? HexColors.allopathic
                              : store.color === Colors.homeopathic
                              ? HexColors.homeopathic
                              : HexColors.ayurvedic
                          }
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M17.5939 22.7911C15.9878 22.7911 14.2179 23.4409 12.6027 24.279C10.0064 25.6266 8.70823 26.301 8.06889 25.8709C7.42956 25.442 7.82588 25.4537 8.06888 22.7912L8.06889 21.4475"
                          stroke={
                            store.color === Colors.allopathic
                              ? HexColors.allopathic
                              : store.color === Colors.homeopathic
                              ? HexColors.homeopathic
                              : HexColors.ayurvedic
                          }
                          strokeWidth="2"
                          strokeLinecap="round"
                        />
                      </svg>
                    </div>
                    <div
                      className="mt-4 font-semibold btn-text"
                      style={{
                        color:
                          store.color === Colors.allopathic
                            ? HexColors.allopathic
                            : store.color === Colors.homeopathic
                            ? HexColors.homeopathic
                            : HexColors.ayurvedic,
                      }}
                    >
                      Chat
                    </div>
                  </button>

                  <button
                    onClick={() => {
                      if (localStorage.access && localStorage.refresh) {
                        history.push("/ambulance", { user: user });
                      } else {
                        history.push("/login");
                        message.warning("Please login");
                      }
                    }}
                    className="single text-xs w-24 h-24 m-1 text-white"
                    style={{
                      borderRadius: "10px",
                      alignItems: "center",
                      boxShadow: "0px 0px 10px 4px rgba(0, 0, 0, 0.05)",
                    }}
                  >
                    <div className="mx-auto w-5 ">
                      <svg
                        className="-ml-1"
                        width="35"
                        height="28"
                        viewBox="0 0 35 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M34.9127 22.8345C33.0226 22.8345 31.3479 22.8345 29.7163 22.8345C28.5927 26.5231 27.0504 27.9887 24.5568 27.8292C22.1248 27.6729 20.6318 26.0448 20.1085 22.9204C19.7237 22.8897 19.3235 22.8376 18.9202 22.8345C17.4918 22.8222 16.0664 22.8314 14.675 22.8314C13.8253 26.2686 12.2923 27.8108 9.83874 27.8016C7.37905 27.7925 5.76902 26.1674 5.08868 22.8621C3.46326 22.8621 1.79782 22.8621 0 22.8621C0 16.3711 0 10.064 0 3.51166C0.628004 3.51166 1.21907 3.51166 1.81013 3.51166C7.81004 3.51166 13.8069 3.47794 19.8068 3.54233C20.9797 3.55459 21.6015 3.26637 21.8047 2.07058C22.0109 0.853319 22.6513 -0.0327964 24.0458 0.000931168C25.3541 0.0315926 25.9606 0.874782 26.1515 2.03992C26.3393 3.19279 27.0011 3.63124 28.1032 4.00838C32.1975 5.40654 34.4879 8.45735 34.8543 12.661C35.1436 15.951 34.9127 19.2839 34.9127 22.8345ZM2.28421 5.73462C2.28421 10.8244 2.28421 15.718 2.28421 20.5962C5.18104 20.7986 5.18104 20.7986 7.34519 19.3422C9.09991 18.1617 10.7777 17.9808 12.4277 19.4341C13.8407 20.679 15.3061 20.725 16.9377 20.6851C17.8089 20.6637 18.6954 20.774 19.5482 20.6514C20.1977 20.5564 20.9181 20.3172 21.4168 19.9094C23.2485 18.4101 25.8621 18.036 27.4875 19.5752C29.1129 21.1175 30.8338 20.5564 32.6532 20.6422C32.6532 18.453 32.6532 16.4324 32.6532 14.2217C28.1371 14.2217 23.7072 14.2217 19.148 14.2217C19.148 11.2905 19.148 8.54934 19.148 5.73462C13.4405 5.73462 7.87161 5.73462 2.28421 5.73462ZM21.5584 12.0999C23.4332 12.0999 25.2095 12.0999 26.9888 12.0999C28.8143 12.0999 30.6368 12.0999 32.5023 12.0999C31.4279 7.06226 27.2813 4.87917 21.5615 6.19454C21.5584 8.05569 21.5584 9.93217 21.5584 12.0999ZM12.1999 23.2208C12.2184 21.9484 11.3226 21.0469 9.99266 21.004C8.55502 20.958 7.5576 21.8135 7.52066 23.1258C7.48372 24.4013 8.52116 25.4714 9.81103 25.4898C11.1132 25.5082 12.1814 24.4933 12.1999 23.2208ZM24.72 21.0009C23.464 21.0101 22.4727 21.9852 22.4696 23.2086C22.4666 24.478 23.5317 25.5296 24.8185 25.5327C26.1238 25.5358 27.1581 24.4933 27.1335 23.2024C27.1058 21.884 26.1268 20.9887 24.72 21.0009Z"
                          fill={
                            store.color === Colors.allopathic
                              ? HexColors.allopathic
                              : store.color === Colors.homeopathic
                              ? HexColors.homeopathic
                              : HexColors.ayurvedic
                          }
                        />
                        <path
                          d="M11.6378 9.97748C12.4987 10.6234 14.2721 9.34789 14.3172 11.6314C14.3656 14.0127 12.4729 12.747 11.5604 13.3668C11.0284 14.1856 12.1473 16.0906 9.89669 15.8949C7.96211 15.7253 9.26151 14.1367 8.64567 13.4288C7.82992 12.4795 5.44716 14.3226 5.57291 11.5726C5.68576 9.09019 7.76221 10.8746 8.478 10.0819C9.4195 9.24677 7.72674 7.14272 10.1159 7.15903C12.431 7.1786 10.7802 9.16848 11.6378 9.97748Z"
                          fill={
                            store.color === Colors.allopathic
                              ? HexColors.allopathic
                              : store.color === Colors.homeopathic
                              ? HexColors.homeopathic
                              : HexColors.ayurvedic
                          }
                        />
                      </svg>
                    </div>
                    <div
                      className="mt-4 font-semibold btn-text"
                      style={{
                        color:
                          store.color === Colors.allopathic
                            ? HexColors.allopathic
                            : store.color === Colors.homeopathic
                            ? HexColors.homeopathic
                            : HexColors.ayurvedic,
                      }}
                    >
                      Ambulance
                    </div>
                  </button>
                  <button
                    onClick={() => {
                      if (localStorage.access && localStorage.refresh) {
                        history.push("/emailfeedback");
                      } else {
                        history.push("/login");
                        message.warning("Please login");
                      }
                    }}
                    className="single2 text-xs w-24 h-24 m-1 text-white"
                    style={{
                      borderRadius: "10px",
                      alignItems: "center",
                      boxShadow: "0px 0px 10px 4px rgba(0, 0, 0, 0.05)",
                    }}
                  >
                    <div className="mx-auto w-5 ">
                      <svg
                        className="-ml-1"
                        width="33"
                        height="23"
                        viewBox="0 0 33 23"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M29.8235 0H2.29412C1.68568 0 1.10216 0.239687 0.671931 0.666332C0.241701 1.09298 0 1.67163 0 2.275V20.475C0 21.0784 0.241701 21.657 0.671931 22.0837C1.10216 22.5103 1.68568 22.75 2.29412 22.75H29.8235C30.432 22.75 31.0155 22.5103 31.4457 22.0837C31.8759 21.657 32.1176 21.0784 32.1176 20.475V2.275C32.1176 1.67163 31.8759 1.09298 31.4457 0.666332C31.0155 0.239687 30.432 0 29.8235 0ZM27.3 2.275L16.0588 9.98725L4.81765 2.275H27.3ZM2.29412 20.475V3.31012L15.405 12.3077C15.597 12.4398 15.8251 12.5106 16.0588 12.5106C16.2925 12.5106 16.5206 12.4398 16.7126 12.3077L29.8235 3.31012V20.475H2.29412Z"
                          fill={
                            store.color === Colors.allopathic
                              ? HexColors.allopathic
                              : store.color === Colors.homeopathic
                              ? HexColors.homeopathic
                              : HexColors.ayurvedic
                          }
                        />
                      </svg>
                    </div>
                    <div
                      className="mt-4 font-semibold btn-text"
                      style={{
                        color:
                          store.color === Colors.allopathic
                            ? HexColors.allopathic
                            : store.color === Colors.homeopathic
                            ? HexColors.homeopathic
                            : HexColors.ayurvedic,
                      }}
                    >
                      {" "}
                      Email
                    </div>
                  </button>

                  <button
                    onClick={() => {
                      if (localStorage.access && localStorage.refresh) {
                        history.push("/pharma", { user: user });
                      } else {
                        history.push("/login");
                        message.warning("Please login");
                      }
                    }}
                    className="text-xs w-24 h-24 m-1 text-white"
                    style={{
                      borderRadius: "10px",
                      alignItems: "center",
                      boxShadow: "0px 0px 10px 4px rgba(0, 0, 0, 0.05)",
                    }}
                  >
                    <div className="mx-auto w-5 ">
                      <svg
                        className="-ml-1"
                        width="30"
                        height="33"
                        viewBox="0 0 30 33"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask id="path-1-inside-1" fill="white">
                          <path d="M25.1573 13.0781C28.6671 15.719 30.3499 19.0468 29.9379 23.2604C29.5114 27.6507 26.3474 31.3149 21.953 32.5596C17.5327 33.8128 12.8098 32.3298 10.0147 28.7245C9.44127 27.9843 8.94564 27.6703 7.92269 27.7769C4.76449 28.1049 1.99242 26.4957 0.675545 23.7651C-0.589463 21.141 -0.0534916 17.8581 2.07887 15.7218C6.52224 11.2671 10.9887 6.83754 15.4666 2.41642C18.5787 -0.653414 23.0394 -0.807606 26.0218 2.00711C29.0244 4.83864 28.9985 9.08875 25.9584 12.2623C25.7308 12.4978 25.5002 12.7305 25.1573 13.0781ZM25.9325 16.1956C23.218 13.5127 20.129 12.467 16.527 13.3893C12.8703 14.3257 10.5593 16.7087 9.77265 20.2971C9.13295 23.2212 9.85046 25.8761 12.0232 28.1918C16.6884 24.1688 21.2355 20.2467 25.9325 16.1956ZM10.7956 9.19528C12.0721 10.3587 12.7637 11.0764 13.5533 11.6652C13.8558 11.8894 14.4523 11.9848 14.8068 11.8586C17.4434 10.9194 20.0483 10.9839 22.6792 11.8754C23.0106 11.9876 23.584 11.9511 23.8059 11.7437C24.5234 11.0708 25.2582 10.3559 25.7509 9.52609C27.0217 7.38702 26.4195 4.67884 24.4427 3.08926C22.5639 1.57817 19.6507 1.41837 17.9304 2.87339C15.5848 4.86107 13.3285 6.94407 10.7956 9.19528ZM13.5129 29.344C16.7086 32.0662 22.1058 31.685 25.3446 28.5899C28.3962 25.6714 29.1253 20.5831 26.8114 17.8721C22.3824 21.6961 17.9534 25.5145 13.5129 29.344ZM9.99453 11.1465C7.88234 13.1146 5.7788 15.0153 3.75882 16.9946C3.13064 17.6086 2.58314 18.3767 2.24024 19.1701C1.43628 21.0232 1.90021 22.7586 3.22285 24.2304C4.53108 25.6855 6.19663 26.2854 8.21661 25.9266C7.01787 20.3196 7.61436 17.4264 12.0462 13.2043C11.3229 12.481 10.5997 11.7549 9.99453 11.1465Z" />
                        </mask>
                        <path
                          d="M25.1573 13.0781C28.6671 15.719 30.3499 19.0468 29.9379 23.2604C29.5114 27.6507 26.3474 31.3149 21.953 32.5596C17.5327 33.8128 12.8098 32.3298 10.0147 28.7245C9.44127 27.9843 8.94564 27.6703 7.92269 27.7769C4.76449 28.1049 1.99242 26.4957 0.675545 23.7651C-0.589463 21.141 -0.0534916 17.8581 2.07887 15.7218C6.52224 11.2671 10.9887 6.83754 15.4666 2.41642C18.5787 -0.653414 23.0394 -0.807606 26.0218 2.00711C29.0244 4.83864 28.9985 9.08875 25.9584 12.2623C25.7308 12.4978 25.5002 12.7305 25.1573 13.0781ZM25.9325 16.1956C23.218 13.5127 20.129 12.467 16.527 13.3893C12.8703 14.3257 10.5593 16.7087 9.77265 20.2971C9.13295 23.2212 9.85046 25.8761 12.0232 28.1918C16.6884 24.1688 21.2355 20.2467 25.9325 16.1956ZM10.7956 9.19528C12.0721 10.3587 12.7637 11.0764 13.5533 11.6652C13.8558 11.8894 14.4523 11.9848 14.8068 11.8586C17.4434 10.9194 20.0483 10.9839 22.6792 11.8754C23.0106 11.9876 23.584 11.9511 23.8059 11.7437C24.5234 11.0708 25.2582 10.3559 25.7509 9.52609C27.0217 7.38702 26.4195 4.67884 24.4427 3.08926C22.5639 1.57817 19.6507 1.41837 17.9304 2.87339C15.5848 4.86107 13.3285 6.94407 10.7956 9.19528ZM13.5129 29.344C16.7086 32.0662 22.1058 31.685 25.3446 28.5899C28.3962 25.6714 29.1253 20.5831 26.8114 17.8721C22.3824 21.6961 17.9534 25.5145 13.5129 29.344ZM9.99453 11.1465C7.88234 13.1146 5.7788 15.0153 3.75882 16.9946C3.13064 17.6086 2.58314 18.3767 2.24024 19.1701C1.43628 21.0232 1.90021 22.7586 3.22285 24.2304C4.53108 25.6855 6.19663 26.2854 8.21661 25.9266C7.01787 20.3196 7.61436 17.4264 12.0462 13.2043C11.3229 12.481 10.5997 11.7549 9.99453 11.1465Z"
                          fill={
                            store.color === Colors.allopathic
                              ? HexColors.allopathic
                              : store.color === Colors.homeopathic
                              ? HexColors.homeopathic
                              : HexColors.ayurvedic
                          }
                        />
                        <path
                          d="M25.1573 13.0781L22.3096 10.2691L19.0982 13.5248L22.7523 16.2744L25.1573 13.0781ZM29.9379 23.2604L25.9568 22.8711L25.9566 22.8737L29.9379 23.2604ZM21.953 32.5596L20.8629 28.7111L20.862 28.7113L21.953 32.5596ZM10.0147 28.7245L6.8527 31.1743L6.85347 31.1753L10.0147 28.7245ZM7.92269 27.7769L8.3359 31.7555L8.33701 31.7554L7.92269 27.7769ZM0.675545 23.7651L-2.92762 25.5021L-2.92736 25.5026L0.675545 23.7651ZM2.07887 15.7218L4.90988 18.5477L4.91091 18.5466L2.07887 15.7218ZM15.4666 2.41642L12.6576 -0.431278L12.6563 -0.430015L15.4666 2.41642ZM26.0218 2.00711L23.2764 4.91614L23.2775 4.91721L26.0218 2.00711ZM25.9584 12.2623L28.8344 15.0424L28.8407 15.0359L28.8469 15.0293L25.9584 12.2623ZM25.9325 16.1956L28.545 19.2246L31.825 16.3956L28.7444 13.3507L25.9325 16.1956ZM16.527 13.3893L17.5193 17.2643H17.5193L16.527 13.3893ZM9.77265 20.2971L5.86544 19.4406L5.86507 19.4423L9.77265 20.2971ZM12.0232 28.1918L9.1061 30.9287L11.7306 33.7259L14.6354 31.221L12.0232 28.1918ZM10.7956 9.19528L8.13832 6.20549L4.81648 9.15791L8.10116 12.1516L10.7956 9.19528ZM13.5533 11.6652L11.1622 14.8718L11.1713 14.8786L13.5533 11.6652ZM14.8068 11.8586L16.1481 15.627L16.149 15.6267L14.8068 11.8586ZM22.6792 11.8754L21.3954 15.6638L21.397 15.6644L22.6792 11.8754ZM23.8059 11.7437L26.5378 14.6655L26.542 14.6615L23.8059 11.7437ZM25.7509 9.52609L22.312 7.48311L22.3116 7.48384L25.7509 9.52609ZM24.4427 3.08926L21.9358 6.2062L21.9361 6.20643L24.4427 3.08926ZM17.9304 2.87339L15.3472 -0.180699L15.3444 -0.178266L17.9304 2.87339ZM13.5129 29.344L10.9006 26.3149L7.36649 29.3628L10.9191 32.389L13.5129 29.344ZM25.3446 28.5899L28.1081 31.4818L28.1093 31.4807L25.3446 28.5899ZM26.8114 17.8721L29.8538 15.2753L27.2422 12.2155L24.1973 14.8445L26.8114 17.8721ZM9.99453 11.1465L12.8305 8.32563L10.1002 5.58079L7.26772 8.22L9.99453 11.1465ZM3.75882 16.9946L6.5547 19.8552L6.55831 19.8517L3.75882 16.9946ZM2.24024 19.1701L5.90978 20.7621L5.91197 20.7571L2.24024 19.1701ZM3.22285 24.2304L0.24765 26.9041L0.24837 26.9049L3.22285 24.2304ZM8.21661 25.9266L8.91625 29.8649L12.9941 29.1405L12.1282 25.0903L8.21661 25.9266ZM12.0462 13.2043L14.8053 16.1004L17.7724 13.2737L14.8747 10.3759L12.0462 13.2043ZM22.7523 16.2744C25.3089 18.198 26.2146 20.2355 25.9569 22.8711L33.9189 23.6498C34.4853 17.8581 32.0253 13.24 27.5623 9.88188L22.7523 16.2744ZM25.9566 22.8737C25.6983 25.5328 23.7638 27.8894 20.8629 28.7111L23.0432 36.4082C28.9311 34.7404 33.3245 29.7686 33.9191 23.6472L25.9566 22.8737ZM20.862 28.7113C17.9582 29.5345 14.9378 28.5462 13.1759 26.2736L6.85347 31.1753C10.6818 36.1133 17.1072 38.0911 23.044 36.408L20.862 28.7113ZM13.1767 26.2746C12.7495 25.7232 12.0291 24.893 10.8902 24.3377C9.68727 23.7513 8.49553 23.6956 7.50836 23.7984L8.33701 31.7554C8.3728 31.7516 7.94035 31.7997 7.38436 31.5286C6.89234 31.2887 6.70648 30.9856 6.85271 31.1743L13.1767 26.2746ZM7.50947 23.7983C6.04338 23.9505 4.86933 23.2527 4.27845 22.0275L-2.92736 25.5026C-0.884487 29.7386 3.4856 32.2592 8.3359 31.7555L7.50947 23.7983ZM4.27871 22.0281C3.75706 20.946 3.96892 19.4903 4.90988 18.5477L-0.752147 12.896C-4.0759 16.2258 -4.93599 21.336 -2.92762 25.5021L4.27871 22.0281ZM4.91091 18.5466C9.34438 14.1018 13.8029 9.68009 18.2769 5.26285L12.6563 -0.430015C8.17444 3.99499 3.70011 8.43233 -0.753175 12.897L4.91091 18.5466ZM18.2757 5.26411C19.9962 3.56696 22.0008 3.71227 23.2764 4.91614L28.7673 -0.901928C24.078 -5.32748 17.1613 -4.87379 12.6576 -0.431278L18.2757 5.26411ZM23.2775 4.91721C24.0148 5.61254 24.2601 6.33739 24.2562 6.98181C24.2521 7.65076 23.9714 8.55419 23.0699 9.49529L28.8469 15.0293C30.9855 12.7969 32.2378 9.98847 32.256 7.03108C32.2744 4.04918 31.0314 1.23321 28.7661 -0.902999L23.2775 4.91721ZM23.0825 9.48222C22.8729 9.69897 22.6624 9.91144 22.3096 10.2691L28.0051 15.8871C28.338 15.5496 28.5886 15.2966 28.8344 15.0424L23.0825 9.48222ZM28.7444 13.3507C25.1862 9.83385 20.6969 8.19249 15.5348 9.51434L17.5193 17.2643C19.5611 16.7414 21.2499 17.1915 23.1206 19.0405L28.7444 13.3507ZM15.5348 9.51434C10.4458 10.8175 6.98255 14.3447 5.86544 19.4406L13.6799 21.1537C14.1361 19.0726 15.2949 17.8339 17.5193 17.2643L15.5348 9.51434ZM5.86507 19.4423C4.93711 23.6839 6.05314 27.6748 9.1061 30.9287L14.9402 25.4549C13.6478 24.0774 13.3288 22.7585 13.6802 21.152L5.86507 19.4423ZM14.6354 31.221C19.3008 27.1979 23.8481 23.2756 28.545 19.2246L23.32 13.1666C18.6229 17.2178 14.076 21.1397 9.41093 25.1626L14.6354 31.221ZM8.10116 12.1516C9.1273 13.0869 10.1643 14.1277 11.1622 14.8718L15.9444 8.45849C15.3632 8.02514 15.017 7.63061 13.4901 6.23894L8.10116 12.1516ZM11.1713 14.8786C12.0112 15.5012 12.919 15.7479 13.5437 15.8454C14.1625 15.942 15.1284 15.9899 16.1481 15.627L13.4654 8.09021C13.8376 7.95772 14.14 7.926 14.3123 7.91774C14.498 7.90882 14.6527 7.92168 14.7774 7.94115C14.9026 7.96068 15.0492 7.99491 15.2157 8.05656C15.37 8.11368 15.634 8.22843 15.9353 8.45174L11.1713 14.8786ZM16.149 15.6267C17.8569 15.0183 19.5325 15.0325 21.3954 15.6638L23.9629 8.08703C20.5641 6.93528 17.0298 6.82055 13.4646 8.09051L16.149 15.6267ZM21.397 15.6644C22.2291 15.9459 23.0505 15.972 23.6774 15.91C24.1541 15.8628 25.4478 15.6845 26.5378 14.6654L21.074 8.82187C21.5706 8.35754 22.0597 8.16103 22.288 8.0829C22.5479 7.99399 22.7572 7.96195 22.8898 7.94883C23.0916 7.92886 23.4607 7.91706 23.9614 8.08649L21.397 15.6644ZM26.542 14.6615C27.2274 14.0188 28.3697 12.9503 29.1903 11.5683L22.3116 7.48384C22.1467 7.76152 21.8194 8.12286 21.0697 8.82587L26.542 14.6615ZM29.1899 11.5691C31.5744 7.55516 30.3261 2.68749 26.9493 -0.0279146L21.9361 6.20643C22.2127 6.42889 22.3523 6.6951 22.3992 6.9196C22.4436 7.13234 22.4111 7.31637 22.312 7.48311L29.1899 11.5691ZM26.9496 -0.027683C23.8679 -2.50628 18.7969 -3.09837 15.3472 -0.180698L20.5135 5.92747C20.4632 5.97003 20.5798 5.8504 20.9678 5.86586C21.3492 5.88106 21.7096 6.02426 21.9358 6.2062L26.9496 -0.027683ZM15.3444 -0.178266C12.9528 1.84836 10.5946 4.02236 8.13832 6.20549L13.4529 12.1851C16.0624 9.86578 18.2167 7.87378 20.5164 5.92504L15.3444 -0.178266ZM10.9191 32.389C15.8752 36.6108 23.5841 35.805 28.1081 31.4818L22.5811 25.698C20.6275 27.5649 17.542 27.5216 16.1068 26.299L10.9191 32.389ZM28.1093 31.4807C30.3358 29.3513 31.6632 26.5021 32.052 23.7036C32.4354 20.944 31.9542 17.7361 29.8538 15.2753L23.7689 20.4689C23.9824 20.7191 24.2937 21.4108 24.1281 22.6028C23.9679 23.7559 23.4051 24.91 22.58 25.6991L28.1093 31.4807ZM24.1973 14.8445C19.7694 18.6675 15.3417 22.4847 10.9006 26.3149L16.1253 32.3731C20.5651 28.5442 24.9954 24.7247 29.4254 20.8998L24.1973 14.8445ZM7.26772 8.22C5.21555 10.1321 3.02689 12.1116 0.95933 14.1375L6.55831 19.8517C8.53071 17.919 10.5491 16.097 12.7213 14.073L7.26772 8.22ZM0.962946 14.134C0.000930756 15.0743 -0.862067 16.2657 -1.4315 17.5832L5.91197 20.7571C6.02835 20.4878 6.26035 20.1429 6.5547 19.8552L0.962946 14.134ZM-1.42931 17.5781C-2.97332 21.1371 -1.9082 24.505 0.24765 26.9041L6.19805 21.5568C5.8983 21.2233 5.85145 21.0341 5.84642 21.0105C5.84368 20.9976 5.84285 20.9891 5.84481 20.9713C5.84697 20.9515 5.85682 20.8842 5.90978 20.7621L-1.42931 17.5781ZM0.24837 26.9049C2.47784 29.3845 5.53124 30.4662 8.91625 29.8649L7.51696 21.9882C7.08619 22.0648 6.86334 22.014 6.75666 21.9772C6.6494 21.9402 6.46037 21.8486 6.19733 21.556L0.24837 26.9049ZM12.1282 25.0903C11.5716 22.4867 11.5844 21.1386 11.8683 20.1369C12.1422 19.1708 12.8248 17.9871 14.8053 16.1004L9.28716 10.3081C6.83574 12.6435 5.00424 15.0175 4.17154 17.9553C3.34894 20.8575 3.6629 23.7594 4.305 26.7628L12.1282 25.0903ZM14.8747 10.3759C14.1548 9.656 13.4342 8.93259 12.8305 8.32563L7.15859 13.9674C7.7651 14.5772 8.49106 15.306 9.21772 16.0327L14.8747 10.3759Z"
                          fill={
                            store.color === Colors.allopathic
                              ? HexColors.allopathic
                              : store.color === Colors.homeopathic
                              ? HexColors.homeopathic
                              : HexColors.ayurvedic
                          }
                          mask="url(#path-1-inside-1)"
                        />
                      </svg>
                    </div>
                    <div
                      className="mt-4 font-semibold btn-text"
                      style={{
                        color:
                          store.color === Colors.allopathic
                            ? HexColors.allopathic
                            : store.color === Colors.homeopathic
                            ? HexColors.homeopathic
                            : HexColors.ayurvedic,
                      }}
                    >
                      {" "}
                      Pharma
                    </div>
                  </button>

                  <button
                    onClick={() => {
                      if (localStorage.access && localStorage.refresh) {
                        history.push("/hospitals", { user: user });
                      } else {
                        history.push("/login");
                        message.warning("Please login");
                      }
                    }}
                    className="text-xs w-24 h-24 m-0.5 text-white"
                    style={{
                      borderRadius: "10px",
                      alignItems: "center",
                      boxShadow: "0px 0px 10px 4px rgba(0, 0, 0, 0.05)",
                    }}
                  >
                    <div className="mx-auto w-5 ">
                      <svg
                        className="-ml-1"
                        width="27"
                        height="31"
                        viewBox="0 0 27 31"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0 31C0 26.2953 0 21.7119 0 16.9768C1.52761 16.872 3.03557 16.7699 4.75694 16.6514C4.75694 12.6361 4.75694 8.66764 4.75694 4.35175C6.9557 4.35175 8.93822 4.35175 10.9236 4.35175C11.2521 4.35175 11.5975 4.40966 11.898 4.32417C12.1479 4.25247 12.3445 4.00703 12.5663 3.8388C12.3754 3.643 12.2153 3.33138 11.9906 3.27622C11.4037 3.13833 10.5669 3.4279 10.6736 2.34686C10.7719 1.34303 11.5526 1.63535 12.1563 1.58296C12.2939 1.57192 12.4287 1.53883 12.6365 1.50298C12.7011 1.02313 12.7629 0.540521 12.8331 0C13.2824 0 13.6895 0 14.181 0C14.2427 0.471577 14.3073 0.954185 14.3803 1.51401C14.9364 1.55814 15.4811 1.5995 16.0933 1.64638C16.5061 2.61987 16.5145 3.3038 15.0908 3.26243C14.8662 3.25692 14.6275 3.643 14.3972 3.84708C14.6668 4.01806 14.9307 4.32969 15.2031 4.3352C17.3906 4.37657 19.581 4.35726 22.0156 4.35726C22.0156 8.56561 22.0156 12.5699 22.0156 16.6817C23.81 16.7782 25.3713 16.861 26.9972 16.9492C26.9972 21.6567 26.9972 26.276 26.9972 30.9972C18.014 31 9.07582 31 0 31ZM19.873 29.1247C19.873 21.5519 19.873 14.0949 19.873 6.64621C15.5148 6.64621 11.3307 6.64621 6.99782 6.64621C6.99782 14.1997 6.99782 21.6402 6.99782 29.1247C11.3364 29.1247 15.5794 29.1247 19.873 29.1247ZM24.981 29.1192C24.981 25.6306 24.981 22.2717 24.981 18.921C23.9504 18.921 23.0406 18.921 22.1307 18.921C22.1307 22.3737 22.1307 25.7299 22.1307 29.1192C23.1276 29.1192 23.9981 29.1192 24.981 29.1192ZM2.03869 18.8741C2.03869 22.3627 2.03869 25.7272 2.03869 29.0861C3.01311 29.0861 3.88081 29.0861 4.76537 29.0861C4.76537 25.6444 4.76537 22.2827 4.76537 18.8741C3.81903 18.8741 2.99064 18.8741 2.03869 18.8741Z"
                          fill={
                            store.color === Colors.allopathic
                              ? HexColors.allopathic
                              : store.color === Colors.homeopathic
                              ? HexColors.homeopathic
                              : HexColors.ayurvedic
                          }
                        />
                        <path
                          d="M12.5381 14.0227C11.4402 14.0227 10.4798 14.0227 9.43237 14.0227C9.43237 13.0106 9.43237 12.0702 9.43237 11.0222C10.4517 11.0222 11.4486 11.0222 12.5381 11.0222C12.5381 12.015 12.5381 12.9554 12.5381 14.0227Z"
                          fill={
                            store.color === Colors.allopathic
                              ? HexColors.allopathic
                              : store.color === Colors.homeopathic
                              ? HexColors.homeopathic
                              : HexColors.ayurvedic
                          }
                        />
                        <path
                          d="M9.48022 16.6589C10.5726 16.6589 11.5358 16.6589 12.5411 16.6589C12.5411 17.6931 12.5411 18.639 12.5411 19.6621C11.5161 19.6621 10.5529 19.6621 9.48022 19.6621C9.48022 18.6914 9.48022 17.7096 9.48022 16.6589Z"
                          fill={
                            store.color === Colors.allopathic
                              ? HexColors.allopathic
                              : store.color === Colors.homeopathic
                              ? HexColors.homeopathic
                              : HexColors.ayurvedic
                          }
                        />
                        <path
                          d="M14.678 16.6177C15.6187 16.6177 16.4499 16.6177 17.399 16.6177C17.399 17.6132 17.399 18.5895 17.399 19.6567C16.5285 19.6567 15.6608 19.6567 14.678 19.6567C14.678 18.7081 14.678 17.7318 14.678 16.6177Z"
                          fill={
                            store.color === Colors.allopathic
                              ? HexColors.allopathic
                              : store.color === Colors.homeopathic
                              ? HexColors.homeopathic
                              : HexColors.ayurvedic
                          }
                        />
                        <path
                          d="M14.6023 13.9839C14.6023 12.9552 14.6023 12.0479 14.6023 11.0386C15.5542 11.0386 16.4585 11.0386 17.4553 11.0386C17.4553 12.0065 17.4553 12.9414 17.4553 13.9839C16.523 13.9839 15.6301 13.9839 14.6023 13.9839Z"
                          fill={
                            store.color === Colors.allopathic
                              ? HexColors.allopathic
                              : store.color === Colors.homeopathic
                              ? HexColors.homeopathic
                              : HexColors.ayurvedic
                          }
                        />
                      </svg>
                    </div>
                    <div
                      className="mt-4 font-semibold btn-text"
                      style={{
                        color:
                          store.color === Colors.allopathic
                            ? HexColors.allopathic
                            : store.color === Colors.homeopathic
                            ? HexColors.homeopathic
                            : HexColors.ayurvedic,
                      }}
                    >
                      {" "}
                      Hospital
                    </div>
                  </button>
                </div>

                <div className="flex">
                  <BookDoctorCard />
                  <div className="quiz">
                    <WellnessCheckCard />
                  </div>
                </div>

                <div className=" lg:flex items-center mt-10  ">
                  <PatientHomeScreenCards
                    image={Corona}
                    title="Covid care"
                    text="Must have vitamins when you are infected with the Novel Corona Virus !"
                    doctor="Dr. Senthil Krishnan"
                  />
                  <PatientHomeScreenCards
                    image={Corona}
                    title="Covid care"
                    text="Must have vitamins when you are infected with the Novel Corona Virus !"
                    doctor="Dr. Senthil Krishnan"
                  />
                </div>

                <div className="xl:hidden">
                  <WellnessCheckCard />
                </div>

                <div
                  className=" md:hidden  mx-auto   mt-4  w-full flex justify-center  "
                  style={{ boxShadow: "0px 0px 0px 0px rgba(0, 0, 0, 0.05)" }}
                >
                  <img
                    src={Logo2}
                    alt=""
                    className="text-center my-10  "
                    style={{ height: "165px" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  })
);

export default Home;
